
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiDelete, mdiNfcVariant, mdiCellphone, mdiArrowRightBold } from "@mdi/js";
import { writeNfcData } from "@/services/nfc";
import { Getter } from "vuex-class";

@Component({
  components: {
    SvgIcon,
  },
})
export default class UserBadgeNfc extends Vue {
  @Prop({ default: false })
  public display: boolean;
  @Prop({ default: false })
  public user: any;

  private badgeNfcList: any[] = [];
  private mdiDelete = mdiDelete;
  private mdiNfcVariant = mdiNfcVariant;
  private mdiCellphone = mdiCellphone;
  private mdiArrowRightBold = mdiArrowRightBold;
  private creatingBadge: boolean = false;
  private deletingBadge: boolean = false;
  private stepCreateBadge: number = 1;
  private nDEFReaderInWindow: boolean = false;

  @Getter private envCompanyId: number|null;
  @Getter private mylobyEnv: string;

  @Watch("display") // watch the 'display' property
  public onDialogOpen(val: boolean, oldVal: boolean) {
    if (val === true && oldVal === false) {
      this.creatingBadge = false;
      this.getBadgeList();
    }
  }

  private mounted(): void {
    this.nDEFReaderInWindow = "NDEFReader" in window;
  }

  private getBadgeList() {
    this.$store.dispatch("badgeNfc/getByUserId", {
      userId: this.user.id,
    }).then((badgeNfcList) => {
      this.badgeNfcList = badgeNfcList;
    });
  }

  private formatDate(value) {
    const date = new Date(value);
    return date.toLocaleDateString(); // Changez cela selon le format que vous souhaitez.
  }

  private async createBadge() {
    const stepCreateToken = async () => {
      this.stepCreateBadge = 1;
      return this.$store.dispatch("badgeNfc/create", {
        userId: this.user.id,
      });
    };
    const stepWriteToken = async (jwt) => {
      this.stepCreateBadge = 2;
      try {
        const abortController = new AbortController();
        await writeNfcData(jwt, "mime", "text/plain", abortController);
      } catch (error) {
        this.$store.commit("alerts/displayError", {
          msg: error,
        });
        if (this.mylobyEnv !== "development") {
          throw error;
        }
      }
    };
    const stepEnableToken = async (id) => {
      this.stepCreateBadge = 3;
      return this.$store.dispatch("badgeNfc/enable", {
        id,
      });
    };
    try {
      this.creatingBadge = true;
      const { id, jwt } = await stepCreateToken();
      await stepWriteToken(jwt);
      await stepEnableToken(id);
      this.stepCreateBadge = 4;
      this.creatingBadge = false;
      await this.getBadgeList();
    } catch (error) {
      // tslint:disable-next-line:no-console
      console.error(error);
      this.creatingBadge = false;
    }

  }

  private deleteBadge(badge) {
    this.deletingBadge = true;
    return this.$store.dispatch("badgeNfc/delete", {
      id: badge.id,
    })
      .then(() => this.getBadgeList())
      .finally(() => this.deletingBadge = false);
  }

  private close(closeObject) {
    this.$emit("close", closeObject);
  }
}
